import React from 'react';
import { MobileOnly } from 'src/ui/block';
import * as S from '../styles';

const advertSpacing = { top: '10px', bottom: '10px' };

const INDEXES = [
  4,
  10,
  16,
  // Ad every 10th price row
  ...Array(16)
    .fill(10)
    .map((v, i) => v + v * i + 16),
];

const getMobileAd = (index: number, mounted: boolean) => {
  const isFirstAdInList = index === INDEXES[0];
  return (
    <S.AdvertTableRowElement key={`mobile-ad-container-${index}`}>
      <MobileOnly>
        <S.AdContainer
          placement={isFirstAdInList ? 'dubbelpanorama1' : 'dubbelpanorama2'}
          format={isFirstAdInList ? 'panorama_1' : 'panorama_2'}
          min={0}
          max={860}
          spacing={advertSpacing}
          triggerPoint={isFirstAdInList ? undefined : 100}
          async={mounted && index > 1}
        />
      </MobileOnly>
    </S.AdvertTableRowElement>
  );
};

const getDesktopAd = (index: number, mounted: boolean) => {
  const isFirstAdInList = index === INDEXES[0];
  return (
    <S.AdvertTableRowElement
      withPosition
      key={`desktop-ad-container-${index}`}
      className="pj-ui-pricelist--advert"
    >
      <S.AdContainer
        min={860}
        max={10000}
        scalable
        scaleBase=".pj-ui-pricelist--advert"
        spacing={advertSpacing}
        placement={isFirstAdInList ? 'panorama_extra' : 'panorama_extra_2'}
        format={isFirstAdInList ? 'panorama_1_wde' : 'panorama_2_wde'}
        triggerPoint={isFirstAdInList ? undefined : 100}
        async={mounted && index > 1}
      />
    </S.AdvertTableRowElement>
  );
};

export const insertTableAds = (tableRows: JSX.Element[], mounted: boolean) => {
  const mobileIndexes = INDEXES;
  // Only max 3 ads in desktop viewport
  const desktopIndexes = INDEXES.slice(0, 3);
  const adjustedMobileAdsIndexes = mobileIndexes.filter(
    index => index <= tableRows.length
  );
  const adjustedDesktopAdsIndexes = desktopIndexes.filter(
    index => index <= tableRows.length
  );

  const tableRowWithAds: JSX.Element[] = [];

  tableRows.forEach((row, index) => {
    tableRowWithAds.push(row);

    if (adjustedMobileAdsIndexes.find(i => i === index + 1))
      tableRowWithAds.push(getMobileAd(index + 1, mounted));

    if (adjustedDesktopAdsIndexes.find(i => i === index + 1))
      tableRowWithAds.push(getDesktopAd(index + 1, mounted));
  });

  // special case for short list
  if (!adjustedMobileAdsIndexes.length)
    tableRowWithAds.push(getMobileAd(0, mounted));
  if (!adjustedDesktopAdsIndexes.length)
    tableRowWithAds.push(getDesktopAd(0, mounted));

  return tableRowWithAds;
};
